module.exports = __webpack_public_path__ + "tibet.3f00c818.svg";